<!--hero section -->
<section class="relative overflow-hidden text-white bg-[radial-gradient(ellipse_58%_70%_at_74%_46%,rgba(0,168,186,0.34),transparent_68%),linear-gradient(180deg,#0c4a6e_0%,#08344c_34%,#041e30_100%)]">
  <div class="mx-auto grid w-[min(1240px,calc(100%-3rem))] grid-cols-1 items-center gap-11 pb-[4.25rem] pt-[3.75rem] lg:grid-cols-[minmax(0,1.2fr)_minmax(320px,0.9fr)] lg:gap-16 lg:pb-[5.25rem] lg:pt-20">
    <div class="max-w-[40rem]">
      <h1 class="m-0 max-w-[18ch] text-[clamp(2.35rem,4.2vw,3.85rem)] font-bold leading-[1.18] tracking-[-0.03em]">O maior sistema de procura em Angola</h1>
      <p class="mt-7 max-w-[36rem] text-[1.2rem] leading-[1.75] text-white/80">
        O que foi perdido, aqui encontra. Pessoas, documentos, veículos e muito mais, de forma rápida.
      </p>
      <div class="mt-[2.35rem] flex flex-wrap gap-[0.9rem]">
        <app-custom-button label="Procurar ocorrências" icon="pi pi-search" link="/ocorrencias"></app-custom-button>
        <app-custom-button label="Criar ocorrência" icon="pi pi-plus" link="/criar" [transparent]="true"></app-custom-button>
      </div>
    </div>

    <div class="mx-auto w-full max-w-[640px] pb-7 lg:max-w-none">
      <div class="relative">
      <svg class="block h-auto w-full" viewBox="0 0 640 560" aria-hidden="true">
        <defs>
          <pattern id="aeHeroDots" width="32" height="32" patternUnits="userSpaceOnUse">
            <circle cx="6" cy="6" r="4.4" fill="#1eb4c8"/>
          </pattern>
          <radialGradient id="aeHeroFade" cx="50%" cy="50%" r="52%">
            <stop offset="0%" stop-color="white"/>
            <stop offset="72%" stop-color="white"/>
            <stop offset="100%" stop-color="black"/>
          </radialGradient>
          <mask id="aeHeroMask">
            <rect width="640" height="560" fill="url(#aeHeroFade)"/>
          </mask>
          <radialGradient id="aePinGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="#ff7900" stop-opacity="0.55"/>
            <stop offset="100%" stop-color="#ff7900" stop-opacity="0"/>
          </radialGradient>
        </defs>

        <rect width="640" height="560" fill="url(#aeHeroDots)" mask="url(#aeHeroMask)"/>
        <circle cx="320" cy="280" r="78" fill="url(#aePinGlow)"/>

        <g fill="none" stroke="#ffffff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M204 108 H320"/>
          <path d="M320 108 V452"/>
          <path d="M182 452 H320"/>
          <path d="M360 280 H400"/>
          <path d="M400 132 V448"/>
          <path d="M400 132 H426"/>
          <path d="M400 448 H424"/>
        </g>

        <g fill="#ffffff">
          <circle cx="320" cy="108" r="7"/>
          <circle cx="262" cy="108" r="5"/>
          <circle cx="204" cy="108" r="7"/>
          <circle cx="320" cy="168" r="5"/>
          <circle cx="320" cy="220" r="5"/>
          <circle cx="320" cy="348" r="5"/>
          <circle cx="320" cy="404" r="5"/>
          <circle cx="320" cy="452" r="7"/>
          <circle cx="250" cy="452" r="5"/>
          <circle cx="182" cy="452" r="7"/>
          <circle cx="380" cy="280" r="5"/>
          <circle cx="400" cy="280" r="7"/>
          <circle cx="400" cy="206" r="5"/>
          <circle cx="400" cy="132" r="7"/>
          <circle cx="426" cy="132" r="7"/>
          <circle cx="400" cy="364" r="5"/>
          <circle cx="400" cy="448" r="7"/>
          <circle cx="424" cy="448" r="7"/>
        </g>
      </svg>

      <div class="absolute left-1/2 top-1/2 z-[3] grid aspect-square w-[12.5%] -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-[linear-gradient(180deg,#ff9a3c_0%,#ff6a00_100%)] shadow-[0_10px_24px_rgba(255,106,0,0.45)]">
        <span class="pointer-events-none absolute inset-0 -z-10 animate-ping rounded-full bg-[rgba(255,121,0,0.45)] motion-reduce:animate-none"></span>
        <span class="pointer-events-none absolute inset-0 -z-10 animate-ping rounded-full bg-[rgba(255,121,0,0.45)] [animation-delay:1.3s] motion-reduce:animate-none"></span>
        <svg class="h-[58%] w-[58%]" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#ffffff" d="M12 2.1c-3.8 0-6.8 3-6.8 6.8 0 5.1 6.8 12.9 6.8 12.9s6.8-7.8 6.8-12.9c0-3.8-3-6.8-6.8-6.8zm0 9.2a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8z"/>
        </svg>
      </div>

      <a class="group absolute left-[19.6875%] top-[19.286%] z-[2] w-[24.375%] -translate-x-1/2 -translate-y-1/2 text-white no-underline focus-visible:outline-none" routerLink="/ocorrencias" [queryParams]="{padrao: 'people'}">
        <img class="block aspect-square w-full rounded-full border-[3px] border-white object-cover object-[center_35%] shadow-[0_12px_28px_rgba(0,10,24,0.38)] transition duration-200 ease-out group-hover:scale-105 group-focus-visible:shadow-[0_0_0_3px_#ffb067,0_12px_28px_rgba(0,10,24,0.38)] motion-reduce:transition-none" src="assets/img/people.png" alt=""/>
        <span class="absolute left-1/2 top-[calc(100%+0.4rem)] -translate-x-1/2 whitespace-nowrap rounded-full border border-white/20 bg-[rgba(4,24,40,0.72)] px-[0.55rem] py-[0.15rem] text-[0.78rem] font-semibold leading-[1.3] backdrop-blur-sm transition group-hover:border-[rgba(255,176,103,0.8)] group-hover:text-[#ffb067] max-sm:px-[0.4rem] max-sm:py-[0.1rem] max-sm:text-[0.68rem]">Pessoas</span>
      </a>
      <a class="group absolute left-[18.4375%] top-[80.714%] z-[2] w-[20%] -translate-x-1/2 -translate-y-1/2 text-white no-underline focus-visible:outline-none" routerLink="/ocorrencias" [queryParams]="{padrao: 'document'}">
        <img class="block aspect-square w-full rounded-full border-[3px] border-white object-cover shadow-[0_12px_28px_rgba(0,10,24,0.38)] transition duration-200 ease-out group-hover:scale-105 group-focus-visible:shadow-[0_0_0_3px_#ffb067,0_12px_28px_rgba(0,10,24,0.38)] motion-reduce:transition-none" src="assets/img/document.png" alt=""/>
        <span class="absolute left-1/2 top-[calc(100%+0.4rem)] -translate-x-1/2 whitespace-nowrap rounded-full border border-white/20 bg-[rgba(4,24,40,0.72)] px-[0.55rem] py-[0.15rem] text-[0.78rem] font-semibold leading-[1.3] backdrop-blur-sm transition group-hover:border-[rgba(255,176,103,0.8)] group-hover:text-[#ffb067] max-sm:px-[0.4rem] max-sm:py-[0.1rem] max-sm:text-[0.68rem]">Documentos</span>
      </a>
      <a class="group absolute left-[79.375%] top-[23.571%] z-[2] w-[25.625%] -translate-x-1/2 -translate-y-1/2 text-white no-underline focus-visible:outline-none" routerLink="/ocorrencias" [queryParams]="{padrao: 'vehicle'}">
        <img class="block aspect-square w-full rounded-full border-[3px] border-white object-cover object-[center_60%] shadow-[0_12px_28px_rgba(0,10,24,0.38)] transition duration-200 ease-out group-hover:scale-105 group-focus-visible:shadow-[0_0_0_3px_#ffb067,0_12px_28px_rgba(0,10,24,0.38)] motion-reduce:transition-none" src="assets/img/vehicle.png" alt=""/>
        <span class="absolute left-1/2 top-[calc(100%+0.4rem)] -translate-x-1/2 whitespace-nowrap rounded-full border border-white/20 bg-[rgba(4,24,40,0.72)] px-[0.55rem] py-[0.15rem] text-[0.78rem] font-semibold leading-[1.3] backdrop-blur-sm transition group-hover:border-[rgba(255,176,103,0.8)] group-hover:text-[#ffb067] max-sm:px-[0.4rem] max-sm:py-[0.1rem] max-sm:text-[0.68rem]">Veículos</span>
      </a>
      <a class="group absolute left-[76.875%] top-[80%] z-[2] w-[21.25%] -translate-x-1/2 -translate-y-1/2 text-white no-underline focus-visible:outline-none" routerLink="/ocorrencias" [queryParams]="{padrao: 'other'}">
        <img class="block aspect-square w-full rounded-full border-[3px] border-white object-cover shadow-[0_12px_28px_rgba(0,10,24,0.38)] transition duration-200 ease-out group-hover:scale-105 group-focus-visible:shadow-[0_0_0_3px_#ffb067,0_12px_28px_rgba(0,10,24,0.38)] motion-reduce:transition-none" src="assets/img/miscellaneous.png" alt=""/>
        <span class="absolute left-1/2 top-[calc(100%+0.4rem)] -translate-x-1/2 whitespace-nowrap rounded-full border border-white/20 bg-[rgba(4,24,40,0.72)] px-[0.55rem] py-[0.15rem] text-[0.78rem] font-semibold leading-[1.3] backdrop-blur-sm transition group-hover:border-[rgba(255,176,103,0.8)] group-hover:text-[#ffb067] max-sm:px-[0.4rem] max-sm:py-[0.1rem] max-sm:text-[0.68rem]">Diversos</span>
      </a>
      </div>
    </div>
  </div>
</section>

        <section class="bg-white">
          <div class="mx-auto w-full max-w-6xl px-6 py-32 lg:py-40">
            <div class="flex flex-wrap justify-center gap-3">
              <button type="button" (click)="selectFlow(0)" [attr.aria-pressed]="activeFlow === 0"
                      [class]="activeFlow === 0
                        ? 'inline-flex items-center rounded-full border border-transparent bg-[linear-gradient(180deg,#ff9a3c_0%,#ff7900_100%)] px-[1.2rem] py-[0.85rem] text-sm font-semibold text-white shadow-[0_12px_26px_rgba(255,121,0,0.32)]'
                        : 'inline-flex items-center rounded-full border border-[#0c4a6e]/35 bg-white px-[1.2rem] py-[0.85rem] text-sm font-semibold text-[#0c4a6e] hover:border-[#0c4a6e] hover:bg-[rgba(12,74,110,0.06)]'">
                Estou à procura
              </button>
              <button type="button" (click)="selectFlow(1)" [attr.aria-pressed]="activeFlow === 1"
                      [class]="activeFlow === 1
                        ? 'inline-flex items-center rounded-full border border-transparent bg-[linear-gradient(180deg,#ff9a3c_0%,#ff7900_100%)] px-[1.2rem] py-[0.85rem] text-sm font-semibold text-white shadow-[0_12px_26px_rgba(255,121,0,0.32)]'
                        : 'inline-flex items-center rounded-full border border-[#0c4a6e]/35 bg-white px-[1.2rem] py-[0.85rem] text-sm font-semibold text-[#0c4a6e] hover:border-[#0c4a6e] hover:bg-[rgba(12,74,110,0.06)]'">
                Encontrei
              </button>
            </div>
            <p class="mx-auto mt-4 max-w-xl text-center text-sm leading-relaxed text-neutral-500">{{ flows[activeFlow].lead }}</p>

            <div class="mt-12 grid items-start gap-14 lg:mt-16 lg:grid-cols-[minmax(0,0.86fr)_minmax(0,1.14fr)] lg:gap-20">
              <div>
                <h2 class="max-w-[14ch] text-5xl font-bold leading-[1.05] tracking-tight text-neutral-900 md:text-6xl">
                  Perdeu-se. Alguém pode ter encontrado.
                </h2>
                <p class="mt-5 max-w-md text-base leading-relaxed text-neutral-500">
                  Não é um serviço pago. É um espaço para publicar e encontrar pessoas, documentos, veículos e outros bens em Angola.
                </p>
              </div>

              <ol class="relative border-l border-neutral-200">
                  @for (step of flows[activeFlow].steps; track step.title; let i = $index) {
                    <li class="relative pb-14 pl-12 last:pb-0">
                      <span class="absolute -left-4 top-0 flex h-8 w-8 items-center justify-center rounded-full bg-sky-700 text-sm font-semibold text-white ring-4 ring-white">{{ i + 1 }}</span>
                      <h4 class="text-base font-semibold text-neutral-900">{{ step.title }}</h4>
                      <p class="mt-1 max-w-lg text-sm leading-relaxed text-neutral-500">{{ step.text }}</p>
                    </li>
                  }
              </ol>
            </div>
          </div>
        </section>

        <!-- section::categories -->
        <section class="bg-white">
          <div class="mx-auto w-full max-w-6xl px-6 py-16 lg:py-24">
              <div class="mx-auto max-w-2xl text-center">
                <h2 class="text-4xl font-bold leading-[1.1] tracking-tight text-neutral-900 md:text-5xl">Categorias</h2>
                <p class="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-neutral-500 md:text-base">
                  Pessoas, documentos, veículos e outros bens. Escolha a categoria e veja o que já foi publicado.
                </p>
              </div>

              <div class="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2">
                @for (category of categoriesCards; track category.padrao) {
                  <a routerLink="/ocorrencias" [queryParams]="{padrao: category.padrao}"
                     class="group relative block aspect-[2/1] overflow-hidden rounded-2xl shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl focus-visible:-translate-y-1 focus-visible:shadow-xl">
                    <span class="absolute inset-0 bg-cover bg-center transition duration-500 group-hover:scale-105"
                          [style.background-image]="'url(assets/img/' + category.src + ')'"></span>
                    <div class="absolute inset-x-0 bottom-0 bg-neutral-950/50 px-8 py-7 transition duration-300 group-hover:bg-neutral-950/65">
                      <h3 class="text-lg font-bold uppercase tracking-wide text-white">{{ category.title }}</h3>
                      <p class="mt-1 line-clamp-2 text-sm leading-relaxed text-white/80">{{ category.description }}</p>
                    </div>
                  </a>
                }
              </div>
          </div>
        </section>

        <section id="como-funciona" class="scroll-mt-8 bg-neutral-50 py-20 mt-20">
          <div class="mx-auto grid w-full max-w-6xl items-start gap-10 px-6 lg:grid-cols-[minmax(0,0.82fr)_minmax(0,1.18fr)]">
            <div>
              <h2 class="mt-4 text-4xl font-bold leading-[1.1] tracking-tight text-neutral-900 md:text-5xl">
                Perguntas<br/>frequentes
              </h2>
              <div class="mt-8 rounded-3xl border border-neutral-200 bg-white p-8 shadow-sm">
                <span class="flex h-14 w-14 items-center justify-center rounded-full bg-orange-50 text-orange-500">
                  <i class="pi pi-map-marker text-xl" aria-hidden="true"></i>
                </span>
                <h3 class="mt-6 text-2xl font-semibold text-neutral-900">Publique o que se perdeu</h3>
                <p class="mt-2 text-sm leading-relaxed text-neutral-500">
                  Se não encontrar o que procura, crie uma ocorrência. A pesquisa continua aberta para todos.
                </p>
                <app-custom-button class="mt-6" label="Criar ocorrência" icon="pi pi-plus" link="/criar"></app-custom-button>
              </div>
            </div>

            <div class="flex flex-col gap-3">
              @for (item of faqs; track item.question; let i = $index) {
                <div class="rounded-2xl border border-neutral-200 bg-white px-5 py-4 shadow-sm"
                     [class.bg-gradient-to-b]="openFaq === i"
                     [class.from-orange-50]="openFaq === i"
                     [class.to-white]="openFaq === i">
                  <button type="button" (click)="toggleFaq(i)"
                          class="flex w-full items-center justify-between gap-4 text-left"
                          [attr.aria-expanded]="openFaq === i">
                    <span class="text-base font-medium text-neutral-900">{{ item.question }}</span>
                    <i class="pi shrink-0 text-neutral-400" aria-hidden="true"
                       [class.pi-times]="openFaq === i" [class.pi-plus]="openFaq !== i"></i>
                  </button>
                  @if (openFaq === i) {
                    <p class="mt-3 max-w-xl pr-8 text-sm leading-relaxed text-neutral-500">{{ item.answer }}</p>
                  }
                </div>
              }
            </div>
          </div>
        </section>


        <section class="mx-auto mb-16 mt-16 w-full max-w-6xl px-6">
          <div class="relative overflow-hidden rounded-3xl bg-[radial-gradient(ellipse_58%_70%_at_74%_46%,rgba(0,168,186,0.34),transparent_68%),linear-gradient(180deg,#0c4a6e_0%,#08344c_34%,#041e30_100%)] md:flex md:min-h-72 md:items-center lg:min-h-80">
            <img src="assets/img/contact-host.png?v=3" alt=""
                 class="pointer-events-none relative z-10 mx-auto mt-6 h-40 w-auto md:absolute md:bottom-0 md:right-3 md:mx-0 md:mt-0 md:h-64 lg:right-6 lg:h-72"/>
            <div class="relative z-20 grid w-full grid-cols-1 gap-8 px-6 py-8 sm:px-10 md:grid-cols-3 md:py-10 lg:px-12 lg:pr-72">
              <div class="min-w-0">
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff9a3c_0%,#ff6a00_100%)] text-white shadow-[0_10px_22px_rgba(255,121,0,0.35)]">
                  <i class="pi pi-phone text-base" aria-hidden="true"></i>
                </span>
                <p class="mt-3 max-w-xs text-xs leading-relaxed text-white/75">Use os terminais abaixo para chamadas ou mensagens</p>
                <a href="tel:+244943009395" class="mt-2 inline-block text-base font-semibold text-white hover:text-orange-200">+244 943 009 395</a>
              </div>

              <div class="min-w-0">
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff9a3c_0%,#ff6a00_100%)] text-white shadow-[0_10px_22px_rgba(255,121,0,0.35)]">
                  <i class="pi pi-envelope text-base" aria-hidden="true"></i>
                </span>
                <p class="mt-3 max-w-xs text-xs leading-relaxed text-white/75">Endereços eletrónicos abaixo entrar em contacto com a nossa equipa</p>
                <a href="mailto:geral@angolaencontra.com" class="mt-2 block max-w-full text-base font-semibold leading-snug text-white hover:text-orange-200">geral&#64;<wbr>angolaencontra.com</a>
              </div>

              <div class="min-w-0">
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff9a3c_0%,#ff6a00_100%)] text-white shadow-[0_10px_22px_rgba(255,121,0,0.35)]">
                  <i class="pi pi-share-alt text-base" aria-hidden="true"></i>
                </span>
                <p class="mt-3 max-w-xs text-xs leading-relaxed text-white/75">Estamos presentes nas redes sociais. Dê o seu suporte e siga-nos.</p>
                <p class="mt-2 text-base font-semibold text-white">
                  <a [href]="socialFacebook" target="_blank" rel="noopener noreferrer" class="hover:text-orange-200">Facebook</a>
                  <span class="mx-2 text-white/45" aria-hidden="true">·</span>
                  <a [href]="socialInstagram" target="_blank" rel="noopener noreferrer" class="hover:text-orange-200">Instagram</a>
                  <span class="mx-2 text-white/45" aria-hidden="true">·</span>
                  <a [href]="socialLinkedIn" target="_blank" rel="noopener noreferrer" class="hover:text-orange-200">LinkedIn</a>
                </p>
              </div>
            </div>
          </div>
        </section>

